import 'slick-carousel/slick/slick.min';

export function stage_slider() {
  $('.stage-slider').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Zurück" role="button"><i class="far fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Weiter" role="button"><i class="far fa-angle-right"></i></button>',
  });
}

export function stage_v2_slider() {
  $('.stage-v2-slider').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Zurück" role="button"><i class="far fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Weiter" role="button"><i class="far fa-angle-right"></i></button>',
  });
}

export function slider_pharmacy_detail_aboutus_images() {
  $('.slider-pharmacy-detail-aboutus-images').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Zurück" role="button"><i class="far fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Weiter" role="button"><i class="far fa-angle-right"></i></button>',
  });
}

export function slider_additional_products() {
  $('.slider-additional-products').slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Zurück" role="button"><i class="far fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Weiter" role="button"><i class="far fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
}

export function monthly_product_slider() {
  $('.monthly-products-slider').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Zurück" role="button"><i class="far fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Weiter" role="button"><i class="far fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
}

export function product_slider() {
  if ($('.product-slider').length > 0) {
    $('.product-slider').each(function () {
      let slidesToShow = 3;
      if (typeof $(this).data('slides') !== 'undefined') {
        slidesToShow = $(this).data('slides');
      }

      $(this).slick({
        dots: false,
        infinite: true,
        slidesToShow: slidesToShow,
        prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Zurück" role="button"><i class="far fa-angle-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Weiter" role="button"><i class="far fa-angle-right"></i></button>',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/slick-carousel.js